module.exports = __webpack_public_path__ + "static/media/md-contract.488ef4f4.svg";